import * as Actions from '../actions'
import * as Validation from '../validation'

Actions.withOperationName(Actions)
Actions.withOperationName(Validation)

export default [
  Actions.startProgress,
  Actions.setMessageIds,
  Actions.setSession,
  Validation.throwOnInvalidSession,
  Actions.configureGateway,
  Actions.loadEmailPreloftData,
  Actions.setUserLocale,
  Actions.setTracingContext,
  Actions.setRecipientEmail,
  Validation.throwOnInvalidRecipient,
  Actions.awaitRecipient,
  Validation.throwOnInvalidPerson,
  Validation.throwOnMissingCreatePersonPermission,
  Validation.throwOnExcludedDomain,
  Actions.setTrackingPreferences,
  Actions.chooseStrategy,
  Actions.updateProgress('preparing_message'),
]
